import { Payment } from "../../models/payment";

export class PartnerPaymentsList {
  constructor(
    public readonly items: Payment[],
    public readonly totalCount: number,
  ) {}
}
